import classNames from 'classnames';
import React, { forwardRef, ReactElement } from 'react';
import styles from './cardWithBorder.module.css';

interface Props {
	borderWidth?: number;
	title?: string | ReactElement;
	/** Content to display in the header of the card. It overrides the `title`. */
	headerContent?: React.JSX.Element[] | JSX.Element;
	children: React.JSX.Element[] | JSX.Element;
	className?: string;
	bodyClassName?: string;
	type?: 'success' | 'warning' | 'danger'
	style?: React.CSSProperties;
	tabIndex?: number;
	onMouseDown?: (event: React.MouseEvent<HTMLDivElement>) => void;
	onMouseUp?: (event: React.MouseEvent<HTMLDivElement>) => void;
	onTouchStart?: (event: React.TouchEvent<HTMLDivElement>) => void;
	onTouchEnd?: (event: React.TouchEvent<HTMLDivElement>) => void;
}

const CardWithBorder = forwardRef((props: Props, ref: React.Ref<HTMLDivElement>): React.JSX.Element => {
	return (
		<div
			ref={ref}
			className={classNames(styles.Card, props.type, props.className)}
			// DO NOT REMOVE: These event listeners are required to allow the card to be dragged via react-draggable
			onMouseDown={props.onMouseDown}
			onMouseUp={props.onMouseUp}
			onTouchStart={props.onTouchStart}
			onTouchEnd={props.onTouchEnd}
			tabIndex={props.tabIndex}
			style={{
				borderTopWidth: props.borderWidth !== undefined ? props.borderWidth : undefined,
				...props.style
			}}
		>
			{props.title && !props.headerContent && (
				<div className={styles.CardHeader}>
					<h4>{props.title}</h4>
				</div>
			)}

			{props.headerContent && (
				<div className={styles.CardHeader}>
					{props.headerContent}
				</div>
			)}

			<div className={classNames(styles.CardBody, props.bodyClassName)}>
				{props.children}
			</div>
		</div>
	);
});

export default CardWithBorder;
